import FeatureToggleSelector from "features/featureToggles/FeatureToggleSelector";
import { useRoutes } from "react-router-dom";
import routeConfig from "routes/routeConfig";
import { useLocale } from "features/i18n/useLocale";
import "./App.less";

export const App = () => {
    const routes = useRoutes(routeConfig);
    const locale = useLocale();
    return (
        <div className="quality-forms-app" lang={locale}>
            {routes}
            <FeatureToggleSelector></FeatureToggleSelector>
        </div>
    );
};
